"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLanguage = exports.supportedLanguages = void 0;
const typeUtils_1 = require("../typeUtils");
exports.supportedLanguages = [
    'en',
    'es',
    'de',
    'fr',
    'it',
    'tr',
    'zh_CN',
    'zh_TW',
    'ru',
    'ja',
    'ko',
    'ar',
    'ca',
    'hi',
    'pl',
    'pt_BR',
    'pt_PT',
];
const isLanguage = (x) => (0, typeUtils_1.isInArray)(x, exports.supportedLanguages);
exports.isLanguage = isLanguage;
